import {
    Autocomplete,
    Box,
    Card,
    Checkbox,
    FormControlLabel,
    Grid,
    TextField,
    Typography,
} from '@mui/material';
// import WeekPicker from '../../../../../components/utils-components/WeekPicker/WeekPicker';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const style = {
    p: 0,
    textAlign: 'left',
    marginLeft: '10px',
};

const ListHeader = ({
    fecha,
    setFecha,
    // hoveredDay,
    // setHoveredDay,
    equipos,
    equipo,
    setEquipo,
    isSemana,
    setIsSemana,
}) => {
    const handleSelectEquipo = (e, newValue) => {
        setEquipo(newValue);
    };

    return (
        <Box sx={style} component="form">
            <Grid container pt={1}>
                <Grid item xs={12}>
                    <Card
                        variant="outlined"
                        sx={{
                            backgroundColor: '#D9D9D9',
                        }}
                    >
                        <Grid
                            container
                            columnSpacing={5}
                            py={2}
                            px={2}
                            alignItems="flex-start"
                            justifyContent="flex-start"
                        >
                            <Grid item xs={12} md={12}>
                                <Typography color="primary" variant="h6">
                                    Filtros
                                </Typography>
                            </Grid>
                            {/* <Grid item xs={2} md="auto">
                                <WeekPicker
                                    value={fecha}
                                    setValue={setFecha}
                                    hoveredDay={hoveredDay}
                                    setHoveredDay={setHoveredDay}
                                />
                            </Grid> */}
                            <Grid item xs={3.5}>
                                <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                    adapterLocale="es"
                                >
                                    <DatePicker
                                        closeOnSelect
                                        displayWeekNumber
                                        format="DD/MM/YYYY"
                                        value={fecha}
                                        onChange={(value) => setFecha(value)}
                                        label="Fecha"
                                        maxDate={dayjs()}
                                        slotProps={{
                                            textField: {
                                                variant: 'standard',
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={2} md="auto">
                                <Autocomplete
                                    value={equipo || null}
                                    options={equipos}
                                    getOptionLabel={(option) =>
                                        `${option.nombre} - ${option.lider?.nombres} ${option.lider?.apellidos}`
                                    }
                                    onChange={handleSelectEquipo}
                                    size="small"
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder=""
                                            variant="standard"
                                            label="Equipo"
                                        />
                                    )}
                                    sx={{ minWidth: 200 }} // Para que tenga un ancho decente
                                />
                            </Grid>
                            <Grid item xs={1} pt={1}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={isSemana}
                                            onChange={(e, value) =>
                                                setIsSemana(value)
                                            }
                                        />
                                    }
                                    label={'Semana'}
                                ></FormControlLabel>
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
};

export default ListHeader;
